import React from 'react';

import { AiDisclaimerContent } from './AiDisclaimerContent';
import { ExternalLinkContent } from './ExternalLinkContent';

export interface DisclaimerProps {
  onAccept: () => void | Promise<void>;
  url?: string;
  onCancel?: () => void;
}

export const Disclaimer: React.FC<DisclaimerProps> = props => {
  const { onAccept, onCancel, url } = props;

  if (url != null && url !== '') {
    return (
      <ExternalLinkContent
        url={url}
        onAccept={onAccept}
        onCancel={onCancel ?? (() => {})}
      />
    );
  }

  return <AiDisclaimerContent onAccept={onAccept} />;
};
